const pubsub = require('../../utils/pubsub');

function isValidOrigin(e) {
	return e.origin === window.location.origin || e.origin === 'https://tpc.googlesyndication.com';
}

function init() {
	window.addEventListener('message', (e) => {
		if (typeof e.data !== 'string' || !isValidOrigin(e)) {
			return;
		}

		let data = (function(raw) {
			try {
				return JSON.parse(raw);
			} catch (err) {
				return false;
			}
		}(e.data));

		if (data && data.type === 'dfpCallback' && typeof data.action === 'string') {
			pubsub.publish(data.action, data.options);
		}
	});
}

module.exports = {
	init
};
